module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/demo.component.css
// module id = ./src/app/demo/demo.component.css
// module chunks = main